import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import FormProblemas from "./FormProblemas";

import ItemInput from './ItemInput';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';

const URL_LOAD = WS.clientes.clienteDados;
const URL_UPDATE = WS.clientes.clienteDadosAtualizar;

export default class PageDados extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      strings: STRINGS[window.LANGUAGE]
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getItemSelect(__args__) {
    const check = __args__.value;
    let resp;
    const arr = __args__.arr;
    arr.map((value,i)=>{
      if(value.value === check){
        resp = arr[i];
        return false;
      }
    });
    return resp;
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;
    const id = this.props.data.id;

    Requisitions({
      url: URL_LOAD,
      data:{ id },
      sucess:function(data){
        var msg;

        _self.initPagseguro(data.sessionId);
        _self.props.onGetData(data);
        if(data.status){
          _self.setState({
            ...data.data,
            loaded: true
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  initPagseguro(sessionId){
    const self = this;
    window.PagSeguroDirectPayment.setSessionId(sessionId);

    window.PagSeguroDirectPayment.onSenderHashReady(function (response)
    {
        if (response.status == 'error')
        {
            const strings = STRINGS[window.LANGUAGE];
            const msg = {
              title: 'Atenção',
              text: 'Ocorreu um erro ao gerar os dados de criação do boleto, caso for gerar um novo boleto, tente recarregar a página'
            };
            Dialog.create(msg);
            return false;
        }

        self.props.onGetHash(response.senderHash);
    });
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const {
      atencao,
      manNotAllowd
    }
    = this.state.strings;

    /*if(target.name==='sexo' && target.value === 'M')
    {
      var msg = {
        title: atencao,
        text: manNotAllowd
      };

      Dialog.create(msg);

      return false;
    }*/

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const id = this.props.data.id;

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    const form = event.target;

    const cpf_cnpj = form.querySelectorAll("[name='cpf_cnpj']")[0].value;
    const sexo = this.state.sexo;
    const nome = form.querySelectorAll("[name='nome']")[0].value;
    const email = form.querySelectorAll("[name='email']")[0].value;
    const data_nascimento = form.querySelectorAll("[name='data_nascimento']")[0].value;
    const telefone = form.querySelectorAll("[name='telefone']")[0].value;

    const formData = this.state;
    formData.problemas = this.state.problemas;
    formData.id = id;

    if(!nome &&
      !email &&
      !data_nascimento &&
      !telefone){
      var msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };

      Dialog.create(msg);
      return false;
    }else{

      Requisitions({
        url: URL_UPDATE,
        data: formData,
        sucess:function(data){
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }
  }

  getProblemasView() {
    return (
      <FormProblemas
        changeProblemas={(problemas) => this.setState({problemas})}
        problemas={this.state.problemas}
      />
    );
  }

  render(){
    const strings = this.state.strings;
    const problemas = this.state.loaded ? this.getProblemasView() : null;
    const cpf_cnpj = this.state.cpf_cnpj;

    return(
      <div>
          <form className=""  onSubmit={this.handleSubmit}>
            <input type='hidden' name='id' value={this.props.data.id} />
            <ItemInput
              onChange={this.handleInputChange}
              value={this.state.validade}
              name="validade"
              title={`${strings.txtValidade}*`}
              placeholder={strings.digiteAqui} />

            <ItemInput
              value={cpf_cnpj}
              name="cpf_cnpj"
              title={`${strings.txtCpf}*`}
              placeholder={strings.digiteCpf}
              onChange={this.handleInputChange}
            />

            <div className='box-sexo-title'>
              <div className='box-title'>
                <span className='title-box-title'>{strings.sexo}</span>
              </div>
              <div className="pure-u-1-2 problema-item">
                <input
                  value="F"
                  name="sexo"
                  type="radio"
                  checked={this.state.sexo==='F'}
                  onChange={this.handleInputChange}
                />
              <span className='type-pay-txt'>{strings.feminino}</span>
              </div>
              <div className="pure-u-1-2 problema-item">
                <input
                  name="sexo"
                  value="M"
                  type="radio"
                  checked={this.state.sexo==='M'}
                  onChange={this.handleInputChange}
                />
              <span className='type-pay-txt'>{strings.masculino}</span>
              </div>
            </div>

            <ItemInput
              onChange={this.handleInputChange}
              value={this.state.nome}
              name="nome"
              title={`${strings.txtNome}*`}
              placeholder={strings.digiteAqui} />
            <ItemInput
              onChange={this.handleInputChange}
              value={this.state.email}
              name="email"
              title={`${strings.txtEmailCadastro}*`}
              placeholder={strings.digiteAqui} />
            <ItemInput
              onChange={this.handleInputChange}
              value={this.state.data_nascimento}
              name="data_nascimento"
              title={`${strings.txtDataNasc}*`}
              placeholder={strings.digiteAqui} />
            <ItemInput
              onChange={this.handleInputChange}
              value={this.state.telefone}
              name="telefone"
              title={`${strings.txtTel}*`}
              placeholder={strings.digiteAqui} />
            {problemas}
            <Button
              text={strings.txtSalvar}
              onClick={this.handleSubmit}
              type='submit'
              classes="button-login simple-button"
            />
          </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/clientes/PageDados.js